export const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];

export const ALLOWED_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-word",
  "application/vnd.ms-word.document.12",
  "application/vnd.ms-office",
  "image/jpeg",
  "image/png"
];

export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB

export const MAX_FILES_COUNT = 5;

export const validateUploadFile = (file) => {
  const fileExtension = file.name.split(".").pop().toLowerCase();
  const isAllowedExtension = ALLOWED_EXTENSIONS.includes(fileExtension);
  const isAllowedMimeType = !file.type || ALLOWED_MIME_TYPES.includes(file.type);

  if (!isAllowedExtension || !isAllowedMimeType) {
    return {
      isValid: false,
      title: "Formato no permitido",
      message: "Solo se permiten archivos en formato PDF, Word (DOC, DOCX), JPG y PNG.",
    };
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      isValid: false,
      title: "Archivo demasiado grande",
      message: "El tamaño máximo permitido es de 50MB.",
    };
  }

  return { isValid: true };
};

export const buildAlertConfig = (type, title, message, onConfirm, onCancel = null) => {
  const config = {
    type,
    title,
    message,
    onConfirm,
  };
  if (onCancel) {
    config.onCancel = onCancel;
  }
  return config;
};
